import jQuery from 'jquery';
(function ($) {
    $("#mobile-responsive-menu")
        .on("sticky.zf.stuckto:top", function () {
            $(this).addClass("inverted");
        })
        .on("sticky.zf.unstuckfrom:top", function () {
            $(this).removeClass("inverted");
        });

    $("#responsive-menu")
        .on("sticky.zf.stuckto:top", function () {
            $(this).addClass("inverted");
        })
        .on("sticky.zf.unstuckfrom:top", function () {
            $(this).removeClass("inverted");
        });
})(jQuery);
